import React from "react";
import ReactDOM from "react-dom/client";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";
import App from "./App";
import Privacy from "./Privacy";
import { createBrowserRouter, RouterProvider } from "react-router-dom"; // Import BrowserRouter and Route
const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
  {
    path: "privacy",
    element: <Privacy />,
  },
]);
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ToastContainer role="alert" />
    <RouterProvider router={router} />
  </React.StrictMode>
);
